import type { FormikProps } from "formik";
import { getIn } from "formik";

import { deepComparison } from "@/utils/compareObject";

export const checkFormikEqual = <
  T,
  TPropsType extends { name: keyof T & string; formik: FormikProps<T> },
>(
  newProps: TPropsType,
  oldProps: TPropsType,
) => {
  const { name: _newName, formik: _newFormik, ...newRestProps } = newProps;
  const { name: _oldName, formik: _oldFormik, ...oldRestProps } = oldProps;

  return deepComparison(oldRestProps, newRestProps)
    ? !(
        newProps.name !== oldProps.name ||
        getIn(newProps.formik.values, oldProps.name) !==
          getIn(oldProps.formik.values, oldProps.name) ||
        getIn(newProps.formik.errors, oldProps.name) !==
          getIn(oldProps.formik.errors, oldProps.name) ||
        getIn(newProps.formik.touched, oldProps.name) !==
          getIn(oldProps.formik.touched, oldProps.name) ||
        Object.keys(oldProps).length !== Object.keys(newProps).length ||
        newProps.formik.isSubmitting !== oldProps.formik.isSubmitting
      )
    : false;
};
